import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { HyperLink } from '../constants/hyperlink';

@Injectable({ providedIn: 'root' })
export class RootEntryGuard implements CanActivate {
  canActivate(route: ActivatedRouteSnapshot): boolean {
    // Leave all SSO callbacks, including incomplete ones, to the login component.
    const hasSsoParams = ['session_state', 'code', 'encrypt_key'].some(
      key => route.queryParamMap.has(key)
    );

    if (hasSsoParams) {
      return true;
    }

    // /about is served outside this Angular router.
    window.location.replace(HyperLink.DOMAIN_VIETTEL_VCONTRACT);
    return false;
  }
}
